import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { FileInfoImplementation } from '../implementation/FileInfoImplementation';
import { GlobalService } from '../services/global.service';
import { Controller } from './Controller';

export class FileInfoController extends Controller{
  public fileInfoImpl: any;
  public universalService: any;
  loggerService: any;
  
  public static singleInstance: any = null;
  pageLimit:any = 50;
  dcGroupCodePicker: any;

  public constructor(public globalService:GlobalService) {
    super(globalService);
    this.fileInfoImpl = FileInfoImplementation.getInstance(globalService);
    this.setEnvObjects(globalService);
  }

  public static getInstance(globalService): FileInfoController {
    if (this.singleInstance == null) {
      this.singleInstance = new FileInfoController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  }

  /**
   * Get al the activities performed on object
   */
  getFileActivities() {
  }

  /**
   * Get all the comments on object
   */
  async getCommentsInFileInfo(selectedObj) {
    var url = "";
    if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.selectedFile["tfKey"]){
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectComments"] + selectedObj.objectKey + "?tfKey=" + selectedObj.tfKey;
    } else {
      if(window.location.href.indexOf("sharedbyme") > -1 ){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]  + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }else{
        // await this.dcGroupCodePicker.decideTypeOfShare(selectedObj.shareKey);
        url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }
    }
    this.fileInfoImpl.setHandler(this.globalService);
    try {
      var result = await this.fileInfoImpl.getFileInfoComments(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for FileInfo Comments", exc);
      return null;
    }
  }

  /**
   * Add the comments on object
   */
  async addFileInfoComment(selectedObj, comment) {
    var url = "";
    if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.selectedFile["tfKey"]){
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectComments"] + selectedObj.objectKey + "?tfKey=" + selectedObj.tfKey;
    } else {
      if(window.location.href.indexOf("sharedbyme") > -1 ){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }else{
        // await this.dcGroupCodePicker.decideTypeOfShare(selectedObj.shareKey);
        url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }
      
    }
    this.fileInfoImpl.setHandler(this.globalService);
    try {
      var result = await this.fileInfoImpl.addFileInfoComment(url, comment);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for FileInfo Comments", exc);
      return null;
    }
  }

  /**
   * delete the comments on object
   */
  async deleteFileInfoComment(selectedObj, commentKey) {
    var url = "";
    if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.selectedFile["tfKey"]){
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectDeleteComments"] + selectedObj.objectKey + "?tfKey=" + selectedObj.tfKey;
    } else {
      if(window.location.href.indexOf("sharedbyme") > -1 ){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }else{
        // await this.dcGroupCodePicker.decideTypeOfShare(selectedObj.shareKey);
        url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["fileInfoComments"] + selectedObj.objectKey + "?shareKey=" + selectedObj.shareKey;
      }
    }
    this.fileInfoImpl.setHandler(this.globalService);
    try {
      var result = await this.fileInfoImpl.deleteFileInfoComment(url, commentKey);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for FileInfo Comments", exc);
      return null;
    }
  }

  /**
   * Get all the Activities on object
   */
  async getActivityInFileInfo(selectedObj, nextLink) {
    var url = "";
    if(nextLink == undefined || nextLink == "" ) {
      if(window.location.href.indexOf("sharedbyme") > -1 ){
        url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["objectAudit"] + selectedObj.objectKey + ENV_CONFIG.commonUrls["sharePath"] + selectedObj.shareKey + "?page=0&limit=" + this.pageLimit;
      }else{
        // await this.dcGroupCodePicker.decideTypeOfShare(selectedObj.shareKey);
        url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["objectAudit"] + selectedObj.objectKey + ENV_CONFIG.commonUrls["sharePath"] + selectedObj.shareKey + "?page=0&limit=" + this.pageLimit;
      }
    } else {
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + nextLink;
    }
    this.fileInfoImpl.setHandler(this.globalService);
    try {
      var result = await this.fileInfoImpl.getFileInfoActivity(url);
      return result;
    } catch (exc) {
      this.loggerService.log("exception handled for FileInfo Activity", exc);
      return null;
    }
  }
}
